<template>
  <div id="app">

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Summary Raporu</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search">
              </v-text-field>



              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>


            </v-toolbar>
          </v-flex>





          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">
              <v-card-title>Filtre Seçimi</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex pa-1 xs12 sm12 md12>
                    <v-card flat="" class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout justify-space-between column>


                            <v-select hide-details :items="hattipiitems" v-model="Params.HatTipi" label="Hat Tipi"
                              item-text="text" item-value="value" max-height="400">
                            </v-select>


                            <v-select hide-details :items="tarihtipiitems" v-model="Params.TarihTip" label="Tarih Tipi"
                              item-text="text" item-value="value" max-height="400">
                            </v-select>



                            <v-autocomplete hide-details="" clearable :items="itemsairlinelist" label="Havayolu Seçimi"
                              item-text="Title" v-model="Params.HavayoluKodu" item-value="HavaYoluKodu">

                            </v-autocomplete>



                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>





                </v-layout>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-container fluid="">

            <v-layout row wrap>

              <v-flex xs12 sm12 md12>
                <v-form ref="formcariyegore" v-model="valid" lazy-validation>
                  <v-card flat>
                    <v-layout row wrap="" class="pa-2 project overdue">

                      <v-flex xs12 sm6 md2>
                        <tarihcomp :etiket="'Başlangıç Tarihi'" v-bind:defaultvalue="'ok'"
                          v-bind:value="Params.BaslangicTarih" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                          v-model="Params.BaslangicTarih"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        <tarihcomp :etiket="'Bitiş Tarihi'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                          v-bind:defaultvalue="'ok'" v-bind:value="Params.BitisTarih" v-model="Params.BitisTarih">
                        </tarihcomp>
                      </v-flex>



                      <v-flex>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small="" dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>

                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>Arama Filtresi Ekle</span>
                            </v-tooltip>



                          </v-badge>


                        </v-layout>
                      </v-flex>



                    </v-layout>
                  </v-card>
                </v-form>
              </v-flex>



              <v-flex xs12 pt-2 sm12 md12>
                <v-layout row wrap="" class=" project overdue">
                  <v-flex xs12 sm12 md12>
                    <v-card flat>
                      <v-data-table dense :headers="headers" class="elevation-1" :rows-per-page-items=[50,100]
                        :loading="progress" :items="items" :search="search3">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">

                          <td class="text-xs-left">{{ props.item.Ay  }}</td>
                          <td class="text-xs-center">{{ props.item.Adet}}</td>
                          <td class="text-xs-right">{{ props.item.Ucret | moneyformat}}{{getparabirimi()}}</td>
                          <td class="text-xs-right">{{ props.item.LostAdet}}</td>
                          <td class="text-xs-right">{{ props.item.LostFare | moneyformat}}{{getparabirimi()}}</td>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                        </v-alert>
                      </v-data-table>
                    </v-card>



                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"

  export default {
    data() {
      return {
        itemsairlinelist: [],
        Params: {
          SirketKodu: null,
          CariKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          HavayoluKodu: null,
          HatTipi: 0, // 0 : Hepsi, 1 : iç hat, 2 : Dış Hat
          TarihTip: false, // false : Satış Tarihine göre, true : fatura tarihine göre
        },

        hattipiitems: [{
          text: 'Hepsi',
          value: 0
        }, {
          text: 'İç Hat',
          value: 1
        }, {
          text: 'Dış Hat',
          value: 2
        }, ],



        tarihtipiitems: [{
          text: 'Satış Tarihine Göre',
          value: false
        }, {
          text: 'Fatura Tarihine Göre',
          value: true
        }],


        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        search: '',
        dovizToplamlar: [],

        headers: [ {
            text: 'Ay',
            value: 'Ay'
          },

          {
            text: 'Adet',
            value: 'Adet',
            align:'center'
          },
          {
            text: 'Ücret',
            value: 'Ucret',
            align:'right'
          },
          {
            text: 'Lost Adet',
            value: 'LostAdet',
            align:'right'
          },
          {
            text: 'Lost Fare',
            value: 'LostFare',
            align:'right'
          }
        ],


        valid: true,

        statecari: [],
        searchcari: '',
        Carihesap: '',
        text1: null,
        loading: false,
        progress: false,
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        search3: '',
        dialogfiltre: false,
        hesapkodu: [],
        Referans: [],
        masrafmerkezi: [],


        tumsirketler: false,

        anahesap: [],
        hesapgurubu: [],
        evraktipi: [],
        mizan: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        tooltip: false,
        el: null,
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp
    },
    mounted() {
      this.el = this.$refs.fab.$el

    },
    watch: {


    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      },
      gethavayolu: function (val) {
        return val.HavayoluKodu + '-' + val.HavayoluAdi
      }
    },
    methods: {

      getparabirimi() {
        return helpers.getparabirimi()
      },
      getList: getList,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
    }
  }

  function filtrele() {

    var params = {
      CompanyCode: 0
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })






    this.dialogfiltre = true



  }

  function filtrekayit() {
    this.filtrevarmi = true
    this.getList();
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.Params.HavayoluKodu = null
    this.ParamsHatTipi = 0 // 0 : Hepsi, 1 : iç hat, 2 : Dış Hat
    this.ParamsTarihTip = false // false : Satış Tarihine göre, true : fatura tarihine göre
    this.dialogfiltre = false
    this.getList();
  }

  function getList() {

    var bastarih = new Date(this.Params.BaslangicTarih)
    var bittarih = new Date(this.Params.BitisTarih)

    if (bastarih <= bittarih) {

      if (this.$refs.formcariyegore.validate()) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Params.SirketKodu = credentials.CariBilgi.SirketKodu
        this.Params.CariKodu = credentials.CariBilgi.Kod

        this.progress = true
        this.load1 = false

        var params = this.Params


        this.$http.post(auth.API_URL + 'api/Dot9/SummaryReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.progress = false
          this.load1 = true

          if (response.body.length > 0) {

            this.items = response.body

          } else {
            this.text1 = 'Kayıt Bulunamadı.';
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
            this.items = [];
          }


        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
          }
        })

      }

    } else {

      this.load1 = true
      this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
      this.snackbar = true

    }



  }


  function getListExcel() {

    var bastarih = new Date(this.Params.BaslangicTarih)
    var bittarih = new Date(this.Params.BitisTarih)

    if (bastarih <= bittarih) {

      if (this.$refs.formcariyegore.validate()) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Params.SirketKodu = credentials.CariBilgi.SirketKodu
        this.Params.CariKodu = credentials.CariBilgi.Kod

        this.progress = true
        this.load1 = false

        var params = this.Params


      this.$http.post(auth.API_URL + 'api/Dot9/SummaryReportExcel', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        },
        responseType: "arraybuffer"
      }).then((response) => {
        this.load = false
        this.load1 = true
        this.progress = false
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "SummaryRapor.xlsx";
        link.click();

      }, (response) => {
        if (response.status === 0) {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        } else {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        }
      })

      }

    } else {

      this.load1 = true
      this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
      this.snackbar = true

    }

}

  function beforeMount() {

  }
</script>

<style>
  .project.complete {
    border-left: 4px solid #039BE5;
  }

  .project.ongoing {
    border-left: 4px solid orange;
  }

  .project.overdue {
    border-left: 4px solid tomato;
  }
</style>